import React, { Component } from 'react'
import _ from 'lib/lodash'

import LinkCardItem from './LinkCardItem'
import CardListHeader from '../../common/list/v1/CardListHeader'

import './LinkCardList.css'

class LinkCardList extends Component {
	render() {
		const { actionHandler, aclAllow, title } = this.props;

		// filter nodes with valid storage information
		const nodes = this.props.nodes;

		// filter for valid storage entries and reverse nodes to have newest on top
		const renderCards = () => _.map(nodes, (node, key) => (
			<LinkCardItem node={node} key={key} actionHandler={actionHandler} aclAllow={aclAllow}/>
		)).reverse();

		return (
			<section>
				<CardListHeader
					nodes={nodes}
					actionHandler={actionHandler}
					title={title}
					titleOne="Link"
					titleMany="Links"
					aclAllow={aclAllow}
				/>
				<div className="md-list-unstyled link-card-list-items">
					{renderCards()}
				</div>
			</section>
		);
	}
}

export default LinkCardList;



// WEBPACK FOOTER //
// ./src/components/cards/link/v1/LinkCardList.jsx